// backwards compatibility layer, may be removed if backend sends enum keys instead
export function fromReadableToEnumEntry(readable: string): string {
  return readable?.replaceAll(' ', '_').toUpperCase();
}
